export default __webpack_public_path__ + "static/media/ico-aws-red-shift-score-moderate.a6e1d392.svg";